<template>
  <div v-loading="loading" style="height: 100%">
    <van-nav-bar
      left-arrow
      :title="title"
      left-text="返回"
      @click-left="$emit('update:show', false)">
    </van-nav-bar>
    <el-table v-if="!loading" :data="procedures">
      <el-table-column align="center" label="工序">
        <template #default="{ row }">
          <van-checkbox v-if="isConfirm" v-model="row.enable" shape="square" @change="changeProcedureSelection">
            {{row.id | valueName('Procedure') | trim}}
          </van-checkbox>
          <div v-else>{{row.id | valueName('Procedure') | trim}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="技师">
        <template #default="{ row }">
          <div @click="openTechnicianPicker(row)" :style="{color: row.enable ?  '#1890ff' : 'gray'}">
            <div v-if="row.technicianId">{{row.technicianName}}</div>
            <div v-else-if="row.teamId">{{row.teamName}}</div>
            <div v-else :style="{color: row.enable ?  'orange' : 'gray'}">请选择</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="开始时间" prop="startTime">
      </el-table-column>
      <el-table-column align="center" label="结束时间" prop="endTime">
      </el-table-column>
    </el-table>

    <div style="width: 100%; display: flex; justify-content: center; margin-top: 50px">
      <van-button style="width: 38%; height: 40px; font-size: 16px; margin-right: 10px" size="small" @click="cancel">
        取消
      </van-button>
      <van-button :loading="confirmLoading"
                  style="width: 38%; height: 40px; font-size: 16px" size="small" type="info" @click="confirm">确定
      </van-button>
    </div>

    <van-popup v-model="picker.show" round position="bottom" style="height: 70%">
      <van-picker
        :loading="picker.loading"
        :title="picker.procedure.dispatch2Team ? '选择工组' : '选择技师'"
        show-toolbar
        :columns="picker.options"
        @cancel="picker.show = false"
        @confirm="onConfirmPickTechnician">
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
  import { Button, Checkbox, NavBar, Picker, Popup, Toast } from 'vant'
  import { calWorkPlan, confirmWork, dispatchWork, teamsOfTechniciansByProcedure } from '@/utils/request'
  import authority from '@/utils/authority'

  export default {
    name: 'WxDispatchPage',
    props: {
      work: {
        type: Object,
        required: true
      },
      pattern: String,
      show: Boolean
    },
    components: {
      [NavBar.name]: NavBar,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [Toast.name]: Toast
    },
    data () {
      return {
        confirmLoading: false,
        picker: {
          show: false,
          procedure: {},
          teamsOfTechnician: [],
          loading: false,
          options: []
        }
      }
    },
    methods: {
      openTechnicianPicker (procedure) {
        if (this.dispatchPattern === 'AUTO' || this.dispatchPattern === 'GRAB') {
          const alertInfo = this.dispatchPattern === 'AUTO' ? '处于自动派工模式' : '处于抢单模式'
          Toast.fail(alertInfo + '，不能手动派工！')
        } else if (procedure.beenWorked && !procedure.technicianInvalid) {
          Toast.fail(`该工序曾经被【${procedure.technicianName}】做过，不能改派！`)
        } else {
          if (!procedure.enable) return
          this.picker.procedure = procedure
          this.picker.show = true
          this.picker.loading = true
          this.picker.options = []
          this.picker.teamsOfTechnician = []
          teamsOfTechniciansByProcedure(procedure.id).then(response => {
            this.picker.teamsOfTechnician = []
            for (const team of response.data) {
              const teamItem = {
                text: team.name
              }
              if (!procedure.dispatch2Team) {
                teamItem.children = []
                for (const technician of team.technicians) {
                  const technicianItem = {
                    text: technician.name
                  }
                  teamItem.children.push(technicianItem)
                }
              }
              if (procedure.dispatch2Team || teamItem.children.length > 0) {
                this.picker.options.push(teamItem)
                this.picker.teamsOfTechnician.push(team)
              }
            }
          }).finally(() => {
            this.picker.loading = false
          })
        }
      },
      onConfirmPickTechnician (value, index) {
        if (!value) return
        if (this.picker.procedure.dispatch2Team) {
          this.picker.procedure.teamId = this.picker.teamsOfTechnician[index].id
          this.picker.procedure.teamName = this.picker.teamsOfTechnician[index].name
          calWorkPlan(this.work.dispatchList).then(response => {
            Object.assign(this.work.dispatchList, response.data)
          }).finally(() => {
            this.picker.show = false
          })
        } else {
          const technician = this.picker.teamsOfTechnician[index[0]].technicians[index[1]]
          this.picker.procedure.technicianId = technician.id
          this.picker.procedure.technicianName = technician.name
          // 如果设置钣金工序，则同时设置装件技师为同一个技师
          if (this.picker.procedure.type === 'SHEET_METAL') {
            for (const procedure of this.work.dispatchList.procedures) {
              if (procedure.type === 'ASSEMBLY') {
                procedure.technicianId = technician.id
                procedure.technicianName = technician.name
                break
              }
            }
          }
          calWorkPlan(this.work.dispatchList).then(response => {
            Object.assign(this.work.dispatchList, response.data)
          }).finally(() => {
            this.picker.show = false
          })
        }
      },
      cancel () {
        this.$emit('closeParent')
      },
      confirm () {
        this.confirmLoading = true
        if (this.isConfirm) {
          confirmWork({
            workId: this.work.id,
            procedures: this.work.dispatchList.procedures
          }).then(() => this.$emit('closeParent'))
            .finally(() => {
              this.confirmLoading = false
            })
        } else {
          dispatchWork({
            workId: this.work.id,
            procedures: this.work.dispatchList.procedures
          }).then(() => this.$emit('closeParent'))
            .finally(() => {
              this.confirmLoading = false
            })
        }
      },
      changeProcedureSelection () {
        // 改变了工单的工序集合，重新计算工作计划
        calWorkPlan(this.work.dispatchList).then(response => {
          Object.assign(this.work.dispatchList, response.data)
        })
      }
    },
    computed: {
      loading () {
        return !this.work.dispatchList
      },
      procedures () {
        if (!this.work.dispatchList) return []
        return this.work.dispatchList.procedures || []
      },
      title () {
        return this.isConfirm ? '确认派工' : '改派'
      },
      isConfirm () {
        return this.pattern === authority.CONFIRM_WORK
      },
      dispatchPattern () {
        return this.$store.state.user.workshop.dispatchPattern
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
